import React, { FC } from 'react';

type VideoProps = {
    url: string;
}

const Video: FC<VideoProps> = ({ url }) => (
    <iframe
        width="560"
        height="315"
        src={url}
        style={{
            maxWidth: '97%',
            position: 'absolute',
            left: 0,
            right: 0,
            margin: 'auto',
            top: '50%',
            transform: 'translateY(-50%)',
        }}
    />
);

export default Video;